// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/policy/cnquery_cnspec_actions.go

import { type Scope, useScope } from "~/hooks/useScope";
import { canAssign } from "./check";

export function useCanAssign(scope?: Scope): boolean {
  const { activeScope } = useScope();
  const withinScope = scope || activeScope;
  const canDoAction = !!withinScope && canAssign(withinScope);
  return canDoAction;
}
